import { startSubmit, stopSubmit } from 'redux-form';
import { fetchAction } from 'barnyard/utils';
import * as constants from '../constants';


export const corporateDataSettingsUpdate = body => dispatch => fetchAction(
  dispatch,
  constants.CORPORATE_DATA_SETTINGS_UPDATE,
  {},
  {
    url: '/api/corporates/corporate/settings/',
    method: 'PATCH',
    body,
    postBefore: () => {
      dispatch(startSubmit(constants.CORPORATE_FORM_NAME));
    },
    postSuccess: () => {
      dispatch(stopSubmit(constants.CORPORATE_FORM_NAME));
    },
    postFailure: (error) => {
      dispatch(stopSubmit(constants.CORPORATE_FORM_NAME), {
        _error: 'Error updating the corporate data settings',
        ...error,
      });
    },
  }
);
